import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import SideNav from './components/SideNav';
import AutoLogout from '../components/core/AutoLogout';
import PermissionDialog from '../components/shared/MCDialog';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { closePermDialog } from '../redux/appSlice';
import AppNavbar from './components/Appbar';

function DashboardLayout() {
	const { permDialog } = useSelector((state: RootState) => state.app);
	const dispatch = useDispatch();

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const toolbarHeight = !isMobile ? 56 : 64;

	const [open, setOpen] = useState(!isMobile);

	const MainContent = styled('main')(({ theme }) => ({
		flexGrow: 1,
		transition: theme.transitions.create(['margin', 'width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginTop: `${toolbarHeight}px`,
		paddingTop: '18px',
		...(open &&
			!isMobile && {
				// marginLeft: 240,
				transition: theme.transitions.create(['margin', 'width'], {
					easing: theme.transitions.easing.easeOut,
					duration: theme.transitions.duration.enteringScreen,
				}),
			}),
	}));

	useEffect(() => {
		if (!isMobile) {
			setOpen(true);
		}
	}, [isMobile]);

	return (
		<>
			<AutoLogout timeoutSeconds={1800} warningDurationSeconds={60} onLogout={window.logout} />
			<PermissionDialog
				open={permDialog?.permDialogOpen ?? false}
				onClose={() => dispatch(closePermDialog())}
				permission={permDialog?.permission ?? ''}
				action={permDialog?.action ?? ''}
			/>
			<Box display="flex">
				<AppNavbar
					open={open}
					setOpen={val => {
						setOpen(val);
					}}
				/>
				<SideNav
					open={open}
					onToggleNav={() => {
						setOpen(!open);
					}}
					isMobile={isMobile}
				/>
				<MainContent sx={{ flexGrow: 1, pb: 6 }}>
					<Outlet />
				</MainContent>
			</Box>
		</>
	);
}

export default DashboardLayout;
